import React, {useState} from "react"
import {Box, IconButton, Stack} from "@mui/material"
import {Warning as WarningIcon} from "@mui/icons-material"
import {useTranslations} from "@cirrus/core/i18n/provider"
import {Counter, PositionContainer, useTooltipStyles} from "./styled"
import {IWarnings} from "./types"
import {Tooltip} from "../../atoms"
import {Warning} from "./Warning"

export const Warnings = ({warnings = [], loading = false, ...props}: IWarnings.WarningsProps) => {
	const {i18n} = useTranslations()
	const [{list, visible}, setStack] = useState({
		visible: false,
		list: warnings
	})

	const handleCloseWarningClick = (id: IWarnings.Warning["id"]) =>
		setStack( (prev) => {
			const _list = list.filter((w) => id !== w.id)
			return {
				visible: _list.length ? prev.visible : false,
				list: _list.length ? _list : warnings,
			}
		})

	const handleToggleButtonClick = () =>
		setStack( (prev) => ({visible: !prev.visible, list: warnings}))

	return (
    <Box position="relative" {...props}>
      <Tooltip classes={{...useTooltipStyles()}} title={!loading && warnings.length === 0 ? i18n("Warnings.Tooltip:NoWarnings") : ""}>
        <IconButton disabled={warnings.length === 0} onClick={handleToggleButtonClick}>
          <WarningIcon />
          {warnings.length > 0 && <Counter>{warnings.length}</Counter> }
        </IconButton>
      </Tooltip>

      {visible && (
        <PositionContainer>
          <Stack sx={{rowGap: "5px", width: 500}}>
            {list.map(({id, message}) =>
              <Warning key={id} message={message} onClose={() => handleCloseWarningClick(id)}/>
            )}
          </Stack>
        </PositionContainer>
      )}
    </Box>
  )
}
